import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import FlexRow from '../../molecules/FlexRow'
import { useTabGroup } from './tabContext'

const useStyles = makeStyles((theme) => ({
  sydMiniTabItem: {
    userSelect: 'none',
    fontWeight: theme.typography.weights.light,

    '&.__selected': {
      fontWeight: theme.typography.weights.bold,
      color: 'var(--color-primary-500)'
    }
  },
  sydMiniTabList: {
    paddingLeft: theme.layout.padding.p10,
    paddingRight: theme.layout.padding.p10,
    '&:not(:first-child)': {
      borderLeft: '1px solid var(--color-neutral-700)'
    }
  }
}))

function SydMiniTabList () {
  const classes = useStyles()
  const { selectedValue, selectValue, options } = useTabGroup()

  return (
    <FlexRow>
      {options.map((o) => (
        <div key={o.value} className={classes.sydMiniTabList}>
          <div
            role='button'
            className={clsx(classes.sydMiniTabItem, { __selected: selectedValue === o.value })}
            onClick={() => selectValue(o.value)}
          >
            {o?.payload?.label || o?.payload}
          </div>
        </div>
      ))}
    </FlexRow>
  )
}

SydMiniTabList.propTypes = {
}

export default SydMiniTabList
